module.exports = __webpack_public_path__ + "resource/img/logo.svg?3750b2d94f8b8cefb9cb218ea414e5d2";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 647
// module chunks = 0 2